import mapToString from './map-to-string.js';
import sortNumbers from './sort-numbers.js';
export default function sort(first, second) {
    if (typeof first === 'number' && typeof second === 'number') {
        return sortNumbers(first, second);
    }
    const firstStr = mapToString(first);
    const secondStr = mapToString(second);
    return firstStr.localeCompare(secondStr);
}
//# sourceMappingURL=sort.js.map